import gql from 'graphql-tag';

export default gql`
  fragment paymentFragment on PaymentType {
    id
    eventId
    paymentMethod
  }
`;
